import React, { ReactElement, useState } from "react";
import styled from "styled-components";

import Button from "./Button";

interface Props {
  text: string;
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
}

export default function InputWithButton({
  value,
  text,
  setValue,
}: Props): ReactElement {
  const [state, setState] = useState(value);
  return (
    <Container>
      <input
        type="number"
        min={0}
        max={1000}
        value={state}
        placeholder="compress value"
        onChange={(e) => {
          setState(parseInt(e.target.value));
        }}
      />
      <Button
        text={text}
        onClick={() => {
          setValue(state);
        }}
      />
      {/* <button
        className="glow-on-hover"
        onClick={() => {
          setValue(state);
        }}
      >
        {text}
      </button> */}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  input {
    border-radius: 5px;
    text-align: center;
  }

  .glow-on-hover {
    width: 150px;
    /* height: 50px; */
    border: none;
    outline: none;
    color: #fff;
    background: #111;
    cursor: pointer;
    position: relative;
    z-index: 0;
    border-radius: 5px;
  }

  .glow-on-hover:before {
    content: "";
    background: linear-gradient(
      45deg,
      #ff0000,
      #ff7300,
      #fffb00,
      #48ff00,
      #00ffd5,
      #002bff,
      #7a00ff,
      #ff00c8,
      #ff0000
    );
    position: absolute;
    top: -2px;
    left: -2px;
    background-size: 400%;
    z-index: -1;
    filter: blur(5px);
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    animation: glowing 20s linear infinite;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    border-radius: 5px;
  }

  .glow-on-hover:active {
    color: #000;
  }

  .glow-on-hover:active:after {
    background: transparent;
  }

  .glow-on-hover:hover:before {
    opacity: 1;
  }

  .glow-on-hover:after {
    z-index: -1;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: #111;
    left: 0;
    top: 0;
    border-radius: 10px;
  }

  @keyframes glowing {
    0% {
      background-position: 0 0;
    }
    50% {
      background-position: 400% 0;
    }
    100% {
      background-position: 0 0;
    }
  }
`;
